import { supabase } from '@/integrations/supabase/client';

export const recipeService = async (dish: string): Promise<string> => {
  try {
    const { data, error } = await supabase.functions.invoke('runAgent', {
      body: {
        agent: 'recipe',
        messages: [{ role: 'user', content: `Please create a detailed, delicious recipe for: ${dish}` }],
        temperature: 0.7,
        stream: false
      }
    });

    if (error) {
      throw new Error(error.message || 'Failed to fetch from runAgent');
    }

    return data.response || '';
  } catch (error) {
    console.error('Recipe generation error:', error);
    return `🍳 **Oops! Kitchen Mishap!** 🍳

I encountered a little trouble in the kitchen while trying to create a recipe for "${dish}". 

Don't worry though! Here's what I suggest:
- Double-check the spelling of the dish name
- Try a simpler version (like "pasta" instead of "pasta puttanesca")  
- Or ask for a different dish altogether!

I'm here and ready to help you create something delicious! 👨‍🍳✨`;
  }
};
